export const SPORTSBOOK_START = 'SPORTSBOOK:START';
export const SPORTSBOOK_BALANCES_UPDATE = 'SPORTSBOOK:BALANCES:UPDATE';
export const SPORTSBOOK_INITIALIZE_ERROR = 'SPORTSBOOK:INITIALIZE:ERROR';
export const SPORTSBOOK_INITIALIZED_UPDATE = 'SPORTSBOOK:INITIALIZED:UPDATE';
export const SPORTSBOOK_INITIALIZING_UPDATE = 'SPORTSBOOK:INITIALIZING:UPDATE';
export const SPORTSBOOK_INTEGRATION_SCRIPT_ERROR = 'SPORTSBOOK:INTEGRATION_SCRIPT:ERROR';
export const SPORTSBOOK_INTEGRATION_SCRIPT_UPDATE = 'SPORTSBOOK:INTEGRATION_SCRIPT:UPDATE';
export const SPORTSBOOK_INTEGRATION_SCRIPT_FETCHED = 'SPORTSBOOK:INTEGRATION_SCRIPT:FETCHED';
export const SPORTSBOOK_INTEGRATION_SCRIPT_FETCHING = 'SPORTSBOOK:INTEGRATION_SCRIPT:FETCHING';

export const startIntegration = () => ({
    type: SPORTSBOOK_START
});

export const updateBalances = (balances) => ({
    type: SPORTSBOOK_BALANCES_UPDATE,
    payload: balances
});

export const setIntegrationScriptURL = (URL) => ({
    type: SPORTSBOOK_INTEGRATION_SCRIPT_UPDATE,
    payload: URL
});

export const setIntegrationScriptFetching = () => ({
    type: SPORTSBOOK_INTEGRATION_SCRIPT_FETCHING
});

export const setIntegrationScriptFetched = () => ({
    type: SPORTSBOOK_INTEGRATION_SCRIPT_FETCHED
});

export const setIntegrationScriptError = () => ({
    type: SPORTSBOOK_INTEGRATION_SCRIPT_ERROR
});

export const setAppInitialized = (isInitialized) => ({
    type: SPORTSBOOK_INITIALIZED_UPDATE,
    payload: isInitialized
});

export const setAppInitializing = (isInitializing) => ({
    type: SPORTSBOOK_INITIALIZING_UPDATE,
    payload: isInitializing
});

export const setAppInitError = () => ({
    type: SPORTSBOOK_INITIALIZE_ERROR
});
